export const SIDE_NAV_WIDTH = 295
export const SIDE_NAV_WIDTH_COLLAPSED = 68
export const SIDE_NAV_HEADER_CLASS_NAME = 'side-nav-header'
